import React, { useEffect, useState } from "react";
import { authApiService } from "../../../api/api";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { ReactComponent as EditModalIcon } from "../../../assets/icons/modal/product.svg";
import { IBrand } from "../../../types/brands.type";
import { ICategory } from "../../../types/category.type";
import { IDiscount } from "../../../types/discount.type";
import { IProduct } from "../../../types/product.type";
import { IProductType } from "../../../types/productType.type";
import { ITags } from "../../../types/tags.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditProductForm from "../forms/EditProductForm/EditProductForm";
import ViewProductForm from "../forms/EditProductForm/ViewProductForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
  product: IProduct;
  tags: ITags[];
  brands: IBrand[];
  categories: ICategory[];
  types: IProductType[];
  discounts: IDiscount[];
}

const EditProductModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteProduct(props.product.id);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення виробу"
              subTitle="Ви дійсно хочете видалити цей виріб? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагування ресурсу"
              subTitle='Редагуйте інформацію про ресурс. Внесіть необхідні зміни та натисніть "Зберегти" для оновлення даних.'
            >
              <EditModalIcon />
            </ModalTitle>
            <EditProductForm
              onClose={() => setIsDelete(true)}
              onApply={onPressApply}
              product={props.product}
              tags={props.tags}
              brands={props.brands}
              categories={props.categories}
              types={props.types}
              discounts={props.discounts}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.upSide}>
                {props.product.previewImageUrl ? (
                  <img
                    src={props.product.previewImageUrl}
                    alt="Avatar"
                    className={styles.avatar}
                  />
                ) : (
                  <div />
                )}
                <button className={styles.upSideButton} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
              <div className={styles.nameContainer}>
                <span className={styles.name}>{`${props.product.name} (${
                  props.product.avaliable ? "Опубліковано" : "Не опубліковано"
                })`}</span>
                <div className={styles.imgContainer}>
                  {props.product.imagesUrls.map((url) => (
                    <img src={url} alt="product" className={styles.img} />
                  ))}
                </div>
              </div>
            </div>
            <ViewProductForm
              product={props.product}
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              onApply={onPressApply}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditProductModal;
